import { Action } from './action';

export class AddSharingToken extends Action {
    constructor(public token: string) {
        super();
    }
}

export class RemoveSharingTokens extends Action {
    constructor(public tokens: string[]) {
        super();
    }
}
